<div class="content">
  <h1 class="large">Восстановление пароля</h1>

  @if (error) {
    <div class="common-error">
      <img src="icons/error_icon.png" alt="error">
      Произошла ошибка: {{ error }}
    </div>
  }
  @if (successMessage) {
    <div class="success-message">
      {{ successMessage }}
    </div>
  }
  <form #f="ngForm" (ngSubmit)="submit(f)">
    <div>
      <input type="email"
             name="email"
             placeholder="Email"
             class="form-input"
             required
             email
             [(ngModel)]="email"
             #emailInput="ngModel">

      @if (emailInput.invalid && (emailInput.touched || emailInput.dirty)) {
        <div class="error">
          Email не валиден
        </div>
      }
    </div>

    <button type="submit"
            class="primary"
            [disabled]="f.invalid || loading || !!successMessage">
      Отправить
    </button>
  </form>

  <div class="login-link">
    <p>Вспомнили пароль?</p>
    <a routerLink="/login">Войти</a>
  </div>
</div>
